import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-commerce',
  templateUrl: './icon-commerce.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconCommerceComponent {}
